<div class="field" #fieldName>
    <span class="field-title">Comprador<span class="asterisk" *ngIf="isRequired">*</span></span>

    <div>
        <div class="form-field" (click)="changeShowOptions()" [ngClass]="{'border-green': isOptionSelected,'is-incomplete': isIncomplete || cramdownProductMismatch}">
            <span class="title-field  {{identifyClassName}}"> 

                <span class="autocomplete"> 
                    <span class="first-part">{{search}}</span> 
                    <span class="second-part">{{placeHolder}}</span>
                </span>

                <input #inputName (focus)="focusField(fieldName)" 
                (blur)="unfocusField()"
                value="{{elementSelected}}" [(ngModel)]="search" placeholder="{{initalElementSelected}}" 
                class="{{identifyClassName}} no-background-border" />
                <!-- <arrow-svg  [active]="true" [direction]="arrowDirection"></arrow-svg> -->
                <img (mouseup)="focusInInput(inputName)" alt="arrow-green" class="{{arrowDirection}} {{identifyClassName}}"
                    src="../../../../../../assets/images/extra/arrow-down-green.svg" />
            </span>
        </div>
        <span class="text-is-incomplete" *ngIf="isIncomplete">Completar la siguiente información para continuar.</span>
        <span class="text-is-incomplete" *ngIf="cramdownProductMismatch">El acuerdo Cramdown es exclusivo para el producto Soja</span>

        <div class="background opaque" *ngIf="showOptions && isGeneratePrice()" (click)="closeSlide()"></div>
        <buyers-generate-price class="slide-card slide-card-visible" *ngIf="showOptions && isGeneratePrice()" (closeEvent)="closeSlide()"
        [options]="arrayOfBuyers" [fieldIdentificator]="fieldIdentificator" (deleteBuyer)="deleteBuyers($event)"></buyers-generate-price>

        <div class="options" *ngIf="showOptions && !isGeneratePrice()">
            <span *ngFor="let element of array | filterByObject: search:OBJECT: 'buyer'; index as i" [ngClass]="{'selected': OBJECT[element]==elementSelected}"
                (click)="setElement(element, i)">
                {{OBJECT[element]}} - {{element}}
            </span>
        </div>
        
    </div>
</div>